import { ViewModel,View, ObservableArray } from "binder"
import moment from "moment";
import { IPopup } from "src/common/userMainWindow/windowContainer/IPopup";
import { WindowViewModel } from "src/common/userMainWindow/windowContainer/windowContainer-viewModel";
import { ServerConnection } from "src/server/serverConnection";
import { PaginationInfo, ServerSideDataLoader } from "uicomponents";
import { WarehouseSelector } from "../rawData/warehouse/warehouseSelector";
import  { WarehouseKeepingView } from "./warehouseKeeping-view"
import { Configuration, WarehouseKeepingDetailViewModel } from "./warehouseKeepingDetail/warehouseKeepingDetail-viewModel";

export class WarehouseKeepingViewModel extends WindowViewModel implements IPopup{
    public getTitle(): string {
        return 'انبار گردانی';
    }
    constructor(parentViewModel: ViewModel) {
        super(parentViewModel);

        this.lineItems = ObservableArray.create<lineItem>();
        this.loader = new ServerSideDataLoader(filteringInformation=>this.refreshPaged(filteringInformation),30);
        this.warehouseSelector = new WarehouseSelector(this);
        this.warehouseSelector.onSelectionChanged = w =>{
            this.warehouseId = w.id;
            this.warehouseName = w.title;
        };
        this.refresh();
    }
    closePopup() {    }
    GetDefaultView(): View <ViewModel> {
        return new WarehouseKeepingView();
    }
    public getTypeId(): string {
        return "VM-CEF35A17-28B4-407A-B545-1E020B889B6E"
    }

    public set warehouseSelector(v: WarehouseSelector) { this._warehouseSelector = v; } public get warehouseSelector(): WarehouseSelector { return this._warehouseSelector;} private _warehouseSelector: WarehouseSelector;
    public set warehouseName(v: string) { this._warehouseName = v; } public get warehouseName(): string { return this._warehouseName;} private _warehouseName: string;
    public set warehouseId(v: string) { this._warehouseId = v; } public get warehouseId(): string { return this._warehouseId;} private _warehouseId: string;
    public set loader(v: ServerSideDataLoader) { this._loader = v; } public get loader(): ServerSideDataLoader { return this._loader;} private _loader: ServerSideDataLoader;
    public set isLoading(v: boolean) { this._isLoading = v; } public get isLoading(): boolean { return this._isLoading;} private _isLoading: boolean;
    public set lineItems(v: ObservableArray<lineItem>) { this._lineItems = v; } public get lineItems(): ObservableArray<lineItem> { return this._lineItems;} private _lineItems: ObservableArray<lineItem>;

    async refresh(){
        await this.loader.refresh();
    }
    async refreshPaged(filteringInformation: any): Promise<PaginationInfo> {
        try {
            this.isLoading = true;
            let result = await ServerConnection.callServer('/Complex/WarehouseKeepingServices/GetAllWarehouseKeepings',{
                FurtherQueryInfo:filteringInformation,
            });
            this.lineItems.update(...result.KeepingList.map((x,i)=>{
                let r = new lineItem(this);
                r.index = i+1;
                r.id = x.Id;
                r.warehouseId = x.WarehouseId;
                r.warehouseName = x.WarehouseName;
                r.startTime = moment.utc(x.StartTime);
                r.finishTime = x.FinishTime == null ? null : moment.utc(x.FinishTime);
                return r;
            }))
            return new PaginationInfo(result.PaginationInfo.CurrentPage,result.PaginationInfo.PageCount);
        } catch (ex) {
            console.log(ex);
            return new PaginationInfo(0,0);
        } finally {
            this.isLoading = false;
        }
    }

    async createWarehouseKeeping() {
        try {
            this.isLoading = true;
            if(this.warehouseSelector.selectedItem==null){
                this.messageBoxConfirmWarning('انبار انتخاب نشده است.','عدم امکان اجرای عملیات')
                return;
            }
            let confirmationResult = await this.messageBoxWarningYesNo(`آیا انبار گردانی جدید برای انبار ${this.warehouseSelector.selectedItem.title} ایجاد شود؟`,'ایجاد انبار گردانی');
            if(confirmationResult=='yes'){
                let result =await ServerConnection.callServer('/Complex/WarehouseKeepingServices/CreateNewWarehouseKeeping',{
                    WarehouseId:this.warehouseSelector.selectedItem.id
                });
                if(result.IsSuccessful){
                    this.messageBoxConfirmSuccess('انبار گردانی جدید ایجاد شد','عملیات موفق');
                    this.refresh();
                }else{
                    this.messageBoxConfirmWarning('خطا در ثبت انبار گردانی','خطا در عملیات');
                }
            }
        } catch (ex) {
            console.log(ex);
            this.messageBoxConfirmWarning('خطا در ثبت انبار گردانی','خطا در عملیات');
        } finally {
            this.isLoading = false;
        }
    }
    
}

export class lineItem extends ViewModel{
    public getTypeId(): string {return '';}
    public GetDefaultView(): View<ViewModel> {return null;}
    constructor(parent:ViewModel) {
        super(parent);
        
    }

    public set index(v: number) { this._index = v; } public get index(): number { return this._index;} private _index: number;
    public set id(v: string) { this._id = v; } public get id(): string { return this._id;} private _id: string;
    public set warehouseId(v: string) { this._warehouseId = v; } public get warehouseId(): string { return this._warehouseId;} private _warehouseId: string;
    public set warehouseName(v: string) { this._warehouseName = v; } public get warehouseName(): string { return this._warehouseName;} private _warehouseName: string;
    public set startTime(v: moment.Moment) { this._startTime = v; } public get startTime(): moment.Moment { return this._startTime;} private _startTime: moment.Moment;
    public set finishTime(v: moment.Moment) { this._finishTime = v; } public get finishTime(): moment.Moment { return this._finishTime;} private _finishTime: moment.Moment;
    
    showDetail(){
        let configuration: Configuration = {
            canPrint : true,
            canCount : true,
            canConfirm : true
        };
        let popup = new WarehouseKeepingDetailViewModel(this, configuration);
        popup.loadById(this.id);
        this.requestShowingPopup(popup);
    }
}
